import { dateRangePickerFields } from "../../filters/components/DateRangePicker";
import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";

// Checkouts only ever hold the two PARTIAL statuses.
const STATUS_OPTIONS = [
  { label: "New", value: "New" },
  { label: "Aggregated", value: "Aggregated" },
];

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Search Shop",
    type: FILTER_TYPES.Query,
    fields: "search_shop",
    fetchReportOnEnterPress: true,
  },
  {
    label: "Search Customer",
    type: FILTER_TYPES.Query,
    fields: "search_customer",
    fetchReportOnEnterPress: true,
  },
  {
    label: "Date",
    type: FILTER_TYPES.DateRange,
    fields: dateRangePickerFields,
    defaultValue: ["", "", ""],
  },
  {
    label: "Status",
    type: FILTER_TYPES.GenericSelect,
    fields: "status_name",
    placeholder: "Select Status",
    options: STATUS_OPTIONS,
  },
];
